/**
 * WhatsApp Float Button - Versión Minimalista
 * Kamuni Design System
 */

class WhatsAppFloatButton {
  constructor() {
    this.button = document.getElementById('whatsapp-float-button');
    this.settings = {
      hideOnPages: ['/checkout', '/cart'],
      showDelay: 500,
      trackingEnabled: true
    };
    
    if (this.button) {
      // Leer configuraciones desde data attributes
      this.settings.trackingEnabled = this.button.dataset.analytics !== 'false';
      
      this.init();
    }
  }

  init() {
    this.setupEventListeners();
    this.handlePageVisibility();
    this.showWithDelay();
  }

  setupEventListeners() {
    // Solo click tracking, sin hover effects complejos
    this.button.addEventListener('click', (e) => {
      this.trackClick();
    });
  }

  handlePageVisibility() {
    const currentPath = window.location.pathname;
    const shouldHide = this.settings.hideOnPages.some(path => 
      currentPath.includes(path)
    );

    if (shouldHide) {
      this.button.style.display = 'none';
      return false;
    }

    return true;
  }

  showWithDelay() {
    setTimeout(() => {
      this.button.style.opacity = '1';
      this.button.style.transform = 'scale(1)';
    }, this.settings.showDelay);
  }

  trackClick() {
    if (!this.settings.trackingEnabled) return;

    // Google Analytics 4
    if (typeof gtag !== 'undefined') {
      gtag('event', 'whatsapp_contact', {
        'event_category': 'Contact',
        'event_label': 'WhatsApp Float Button'
      });
    }

    // Console log para debugging
    console.log('WhatsApp button clicked');
  }

  // Método para mostrar/ocultar manualmente
  show() {
    this.button.style.display = 'block';
    this.button.style.opacity = '1';
    this.button.style.transform = 'scale(1)';
  }

  hide() {
    this.button.style.display = 'none';
  }
}

// Inicializar cuando el DOM esté listo
document.addEventListener('DOMContentLoaded', function() {
  window.whatsappFloat = new WhatsAppFloatButton();
});

// Exportar para uso global
window.WhatsAppFloatButton = WhatsAppFloatButton;
